import { render } from "./poweredByTaptasty.vue?vue&type=template&id=27d5f5d8"
const script = {}

import exportComponent from "/home/sergiugata/taptasty/-taptasty-order/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__